import styled from 'styled-components';

export const PageTitle = styled("h2")`
    color: #EB5757;
    font-size: 54px;
`;
